import APIRequestState from '../_util/api-request';

/* body: {number} number */
class MobileLink extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/mobile/link'; }
}

export default MobileLink;



// WEBPACK FOOTER //
// ./spa/state/session/mobile-link.jsx